import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
/***
 * ANIMAZIONE DETAILCATEGORY
 */
const scrollerDetailCategory = document.querySelector(".scrollerDetailCategory");
if (scrollerDetailCategory !== null) {
    gsap.registerPlugin(ScrollTrigger);

    $(".dezoomactivator").each(function (i, el) {
        const dezoomitem = $(el).find(".dezoomitem");
        const delay = parseInt($(el).data("delay"));
        gsap.to(dezoomitem, {
            scale: 1,
            ease: "power2.out",
            duration: 1,
            delay: delay,
            scrollTrigger: {
                trigger: el,
                start: "top 85%",
                end: "top 5%",
            },
        });
    });


    /***const itemssquare = gsap.utils.toArray(".img-container-clipped-square");

    itemssquare.forEach((item, i) => {
        gsap.to(item, {
            clipPath: "polygon(25% 25%, 75% 25%, 75% 75%, 25% 75%);",
            duration: 4,
            ease: "none",
            scrollTrigger: {
                trigger: item,
                start: "top 95%",
                end: "top 5%",
                scrub: 4,
                markers: true,
            },
        });
    });
    **/
}
